import React, { useEffect, useState } from 'react';
import {
  Box, Grid, TextField, Button, Typography,
  MenuItem, FormControl, InputLabel, Select
} from '@mui/material';
import {
  API_GET_STUDENTS,
  API_ADD_FEE,
  API_GET_FEES_BOOKS_MASTER,
  API_UPDATE_FEE,
} from "../Config/ApiUrlConstant";
import { useAuth } from "../AuthContext";
import { ClassListArray } from "../Common/Component/CommonComponents";

const AddStudentFeeForm = ({ onSuccess, initialData = null, mode = "add" }) => {
  const isEdit = mode === "edit";
  const { logout } = useAuth();

  const [formData, setFormData] = useState({
    id: '',
    class_no: '',
    student_id: '',
    fee_months: [],
    tuition_charge: 0,
    magic_charge: 0,
    fee_pending: 0,
    description: '',
    discount: 0,
    created_at: new Date().toISOString().split('T')[0],
  });

  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [feesBooks, setFeesBooks] = useState([]);

  // Fetch students
  const getAllStudents = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(API_GET_STUDENTS, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      if (res.status === 401 || res.status === 403) { logout(); return; }
      const data = await res.json();
      setStudents(data.data || []);
    } catch (err) { console.error("Error fetching students:", err); }
  };

  // Fetch feesBooks
  const getAllFeesBooksMaster = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(API_GET_FEES_BOOKS_MASTER, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      if (res.status === 401 || res.status === 403) { logout(); return; }
      const data = await res.json();
      setFeesBooks(data.data || []);
    } catch (err) { console.error("Error fetching feesBooks:", err); }
  };

  // Set initialData for edit
  useEffect(() => {
    if (initialData) {
      console.log("kam initialData->", initialData)
      let months = [];
      if (initialData.fee_month) {
        months = Array.isArray(initialData.fee_month)
          ? initialData.fee_month.map(m => m.substring(0, 7)) // keep only YYYY-MM
          : initialData.fee_month.split(',').map(m => m.substring(0, 7));
      }
      console.log("kam months->", months);
      setFormData({
        id: initialData.id || '',
        class_no: initialData.class || '',
        student_id: initialData.student_id || '',
        fee_months: months,
        tuition_charge: initialData.tuition_charge || 0,
        magic_charge: initialData.magic_charge || 0,
        fee_pending: initialData.fee_pending || 0,
        description: initialData.description || '',
        discount: initialData.discount || 0,
        created_at: initialData.created_at?.split("T")[0] || new Date().toISOString().split('T')[0],
      });
    }
  }, [initialData]);

  useEffect(() => {
    getAllStudents();
    getAllFeesBooksMaster();
  }, []);

  // Filter students & auto tuition based on class
  useEffect(() => {
    const filtered = students.filter(s => s.class == formData.class_no);
    setFilteredStudents(filtered);

    const feeBook = feesBooks.find(f => f.class == formData.class_no);
    if (feeBook) {
      setFormData(prev => ({ ...prev, tuition_charge: feeBook.fee_amt || prev.tuition_charge }));
    }
  }, [formData.class_no, students, feesBooks]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleMonthChange = (e) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      fee_months: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const apiUrl = isEdit ? API_UPDATE_FEE : API_ADD_FEE;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData),
      });

      const responseData = await response.json();
      if (response.status === 401 || response.status === 403) { logout(); return; }

      if (responseData.status) {
        if (onSuccess) onSuccess();
      } else {
        alert(responseData.message || "Something went wrong.");
      }
    } catch (err) {
      console.error("Error submitting fee:", err);
    }
  };

  return (
    <Box>
      {/* <Typography variant="h6" gutterBottom>
        {isEdit ? "Update Fee" : "Add Monthly Fee"}
      </Typography> */}
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* Class */}
          <Grid item xs={12} sm={6} style={{ width: '120px' }}>
            <FormControl fullWidth required>
              <InputLabel>Class</InputLabel>
              <Select
                name="class_no"
                value={formData.class_no}
                onChange={handleChange}
                label="Class"
              >
                <MenuItem value="">Select Class</MenuItem>
                {ClassListArray.map(cls => (
                  <MenuItem key={cls.value} value={cls.value}>{cls.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Student */}
          <Grid item xs={12} sm={6} style={{ width: '290px' }}>
            <FormControl fullWidth required>
              <InputLabel>Student</InputLabel>
              <Select
                name="student_id"
                value={formData.student_id}
                onChange={handleChange}
                disabled={!formData.class_no}
              >
                <MenuItem value="">Select Student</MenuItem>
                {filteredStudents.map(s => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.student_name} ({s.student_father_name})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Months */}
          <Grid item xs={12} sm={6} style={{ width: '200px' }}>
            <FormControl fullWidth required>
              <InputLabel>Fee Months</InputLabel>
              <Select
                multiple
                name="fee_months"
                value={Array.isArray(formData.fee_months) ? formData.fee_months : []}
                onChange={handleMonthChange}
                renderValue={(selected) => selected.join(', ')}
              >
                {Array.from({ length: 12 }, (_, i) => {
                  const today = new Date();
                  const startMonth = 4; // April
                  const currentYear = today.getFullYear();
                  const sessionStartYear = today.getMonth() >= startMonth ? currentYear : currentYear - 1;
                  const monthIndex = (startMonth + i) % 12;
                  const yearOffset = Math.floor((startMonth + i) / 12);
                  const year = sessionStartYear + yearOffset;
                  const month = new Date(year, monthIndex).toISOString().slice(0, 7);
                  return <MenuItem key={month} value={month}>{month}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>

          {/* Charges */}
          <Grid item xs={12} sm={6}>
            <TextField
              name="tuition_charge"
              label="Tuition Charge"
              type="number"
              fullWidth
              value={formData.tuition_charge}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="magic_charge"
              label="Magic Charge"
              type="number"
              fullWidth
              value={formData.magic_charge}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="fee_pending"
              label="Fee Pending"
              type="number"
              fullWidth
              value={formData.fee_pending}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="discount"
              label="Discount"
              type="number"
              fullWidth
              value={formData.discount}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="description"
              label="Description"
              fullWidth
              value={formData.description}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="created_at"
              label="Created Date"
              type="date"
              fullWidth
              value={formData.created_at}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" type="submit" fullWidth>
              {isEdit ? "Update Fee" : "Add Fee"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default AddStudentFeeForm;
